import { createTheme } from '@mui/material/styles';

const muiTheme = createTheme({
  components: {
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: "#d32f2f", // red star
          fontWeight: 700,
        },
      },
    },
  },
});

export default muiTheme;
